import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useBaseParam } from '../hooks/useBaseParam';
import { fetchLoanPreviewPromotion } from '../../infra/api/fetchLoanPreviewPromotion';
import useCheckBottomsheet from '../hooks/useCheckBottomsheet';

const usePromotion = () => {
  const params: any = useParams();
  const [searchParams] = useSearchParams();
  const queries = Object.fromEntries(Array.from(searchParams));

  // popup
  const [popup] = useState({
    open: false,
    message: '신청이 완료되었어요.',
    hasConfirmButton: false,
    hasCancelButton: false,
  });

  // floating
  const [floating, setIsFloating] = useState({
    isFloating: false,
    setFloating: (v: boolean) => {
      setIsFloating((prev) => ({
        ...prev,
        isFloating: v,
      }));
    },
  });

  // promotion
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [promo, setPromo] = useState<any>({});
  const [isEntry] = useState<boolean>(false);
  const getPromotion = useBaseParam(fetchLoanPreviewPromotion, {
    promotionSeq: params.promoSeq,
    token: queries.token,
  });

  useEffect(() => {
    (async () => {
      const [resPromotion] = await Promise.all([getPromotion()]);
      if (resPromotion?.data?.isSucceed === true) {
        const result = resPromotion.data.result;
        setPromo(result);

        const termList =
          result?.promotionTerms?.termsList?.map((item: any) => ({
            text: item.title,
            required: item.requiredYn === 'Y',
            guideText: '',
            termCd: item.promotionTermsSeq,
            type: 'term',
            path: item.termsFileUrl,
            checked: true,
            key: item.termCd,
            subTextItem: [],
          })) || [];
        setTermList(termList);

        setTermActiveCondition(
          result?.promotionTerms?.termsButtonActiveRequirement,
        );
      }
      setIsLoading(true);
    })();
  }, []);

  const isInactiveButton = (
    inactiveButtonYn: 'Y' | 'N',
    inactiveButtonRequirement: 'promotion_participate',
  ) => {
    if (inactiveButtonYn === 'N') return false;
    else {
      if (inactiveButtonRequirement === 'promotion_participate') {
        return isEntry;
      }
    }
    return false;
  };

  // 약관
  const [termList, setTermList] = useState<any[]>([]);
  const [termActiveCondition, setTermActiveCondition] = useState('');
  const [termFullSheet, setTermFullSheet] = useState({
    open: false,
    title: '',
    path: '',
    close: () => {
      setTermFullSheet((prev) => ({
        ...prev,
        open: false,
        title: '',
        path: '',
        termsCd: '',
      }));
    },
    show: (title: string, path: string, termsCd: string) => {
      setTermFullSheet((prev) => ({
        ...prev,
        open: true,
        title,
        path,
        termsCd,
      }));
    },
  });
  const checkBottomsheet = useCheckBottomsheet(termList, termActiveCondition);
  //

  const showTermDetail = (idx: number) => {
    const term = termList[idx];
    termFullSheet.show(term.text, term.path, term.termsCd);
  };

  const actByPromotionLink = (
    linkType: 'in_app' | 'out_link' | 'terms',
    redirectionUrl?: string,
  ) => {
    if (linkType === 'out_link' && redirectionUrl) {
      // br.openExternalBrowser({ url: redirectionUrl });
    } else if (linkType === 'in_app') {
      // 추후 추가
    } else if (linkType === 'terms') {
      checkBottomsheet.open();
    }
  };

  const applyPromotion = async () => {};

  const termAgreeButtonName =
    promo?.promotionTerms?.promotionAgreeButtonName || '';

  return {
    isLoading,

    promo,
    isEntry,

    actByPromotionLink,
    isInactiveButton,
    applyPromotion,

    popup,
    floating,

    termAgreeButtonName,
    checkBottomsheet,
    showTermDetail,
    termFullSheet,
  };
};

export default usePromotion;
